<template>
    <page :tabs="tabs" class="pb-2">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import page from '../../generic/page/page.vue';

    export default {
        components: {
            page,
        },
        name: 'AiReport',
        data() {
            return {
                busy: false,
            };
        },
        computed: {
            ...mapGetters('header', ['userCurrencySymbol']),
            tabs() {
                const tabs = [];
                tabs.push({
                    title: 'AI Messages Report',
                    active: this.$route.path === `/app/admin/ai-report/message/`,
                    route: `/app/admin/ai-report/message/`,
                })
                tabs.push({
                    title: 'AI Usage Report',
                    active: this.$route.path === `/app/admin/ai-report/usage/`,
                    route: `/app/admin/ai-report/usage/`,
                })
                return tabs;
            }
        },
        mounted() {
            if (this.$route.path === '/app/admin/ai-report/') {
                this.$router.push('/app/admin/ai-report/message/');
            }
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
        },
    };
</script>

<style lang="scss" scoped>
</style>
